module.exports = __webpack_public_path__ + "static/media/planner.58bfa5fa.png";